import { Effect, Reducer } from 'umi';
import { getGameConfig } from '@dbl/services/global';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const namespace = 'exploreAnalysisGames';

interface ExploreAnalysisGamesStateType {
  exploreGame: string[];
}


interface ExploreAnalysisGamesType {
  namespace: string;
  state: ExploreAnalysisGamesStateType;
  effects: {
    getExploreAnalysisGameList: Effect;
  };
  reducers: {
    save: Reducer<ExploreAnalysisGamesStateType>;
  };
}

const ExploreAnalysisGames: ExploreAnalysisGamesType = {
  namespace,
  state: {
    exploreGame: [],
  },
  reducers: {
    save(state: ExploreAnalysisGamesStateType, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  effects: {
    *getExploreAnalysisGameList(action, { put }) {
      try {
        const gameConfig: {explore_open: boolean; game_code: string;}[] = yield getGameConfig();
        const games = gameConfig?.filter((item: any) => item.explore_open)?.map((item: any) => item.game_code) || [];
        yield put({
          type: "save",
          payload: {
            exploreGame: games
          }
        });
      } catch (e) {
        yield put({
          type: "save",
          payload: {
            exploreGame: [],
          }
        });
      }
    },
  }
};

export default ExploreAnalysisGames;